import { c as _c } from "react/compiler-runtime";
import { Pagination } from '@onefootprint/ui';
import useRoles from '@/components/roles/hooks/use-roles';
import RolesTable from '@/components/roles/roles-table';
const Table = () => {
  const $ = _c(10);
  const {
    data: response,
    errorMessage,
    isPending,
    pagination
  } = useRoles("api_key");
  const t0 = response?.data;
  let t1;
  if ($[0] !== errorMessage || $[1] !== isPending || $[2] !== t0) {
    t1 = <RolesTable data={t0} errorMessage={errorMessage} isPending={isPending} kind="api_key" />;
    $[0] = errorMessage;
    $[1] = isPending;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== pagination || $[5] !== response) {
    t2 = response && response.meta.count > 0 && <Pagination hasNextPage={pagination.hasNextPage} hasPrevPage={pagination.hasPrevPage} onNextPage={pagination.loadNextPage} onPrevPage={pagination.loadPrevPage} pageIndex={pagination.pageIndex} pageSize={pagination.pageSize} totalNumResults={pagination.count} />;
    $[4] = pagination;
    $[5] = response;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <section data-testid="roles-table">{t1}{t2}</section>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default Table;